import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { INSIGHTS_STORIES } from '../data/insights';

function formatDate(dateString) {
  if (!dateString) return 'XX';
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return dateString;
  return date.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

function formatReadTime(readTimeMinutes) {
  if (typeof readTimeMinutes === 'number') return `${readTimeMinutes} min read`;
  return `${readTimeMinutes || 'XX'} min read`;
}

function Insights() {
  return (
    <div className="page-wrapper">
      <Helmet>
        <title>Clariti AI Insights | Banking Strategy & Data Analysis</title>
        <meta name="description" content="Insights on banking pricing strategy, mortgage and savings analytics, and market trends from the Clariti AI team." />
        <link rel="canonical" href="https://www.clariti.ai/insights" />
        <meta property="og:title" content="Clariti AI Insights | Banking Strategy & Data Analysis" />
        <meta property="og:description" content="Expert thought leadership on pricing optimisation, analytics, and market intelligence for banks." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.clariti.ai/insights" />
        <meta name="twitter:title" content="Clariti AI Insights | Banking Strategy & Data Analysis" />
        <meta name="twitter:description" content="Read practical insights on pricing optimisation and data analytics for global banking teams." />
      </Helmet>
      {/* Hero */}
      <section className="resources-hero">
        <div className="container">
          <h1>Insights</h1>
          <p>Thoughts on pricing strategy, data, and the future of banking.</p>
        </div>
      </section>

      {/* Story index */}
      <section className="insights-index-section">
        <div className="container">
          <div className="insights-grid">
            {INSIGHTS_STORIES.map((story) => (
              <article key={story.slug} className="insight-card">
                <p className="insight-card-kicker">{story.category}</p>
                <h2>{story.title}</h2>
                <p className="insight-card-meta">
                  {formatDate(story.publishedDate)} · {formatReadTime(story.readTimeMinutes)}
                </p>
                <p className="insight-card-excerpt">{story.excerpt}</p>
                <p className="insight-card-meta">
                  Explore related solutions:
                  {' '}
                  <Link to="/products/mortgage">Mortgage</Link>
                  {' '}
                  |
                  {' '}
                  <Link to="/products/savings">Savings</Link>
                </p>
                <Link to={`/insights/${story.slug}`} className="insight-card-link">
                  Read story →
                </Link>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Insights;

